import PageTitle from "../../components/PageTitle";
import Tx from "../../components/Tx";
import { api } from "../../maps/data.js";
import Table from '../../components/Table';
import { useEffect, useState } from "react";
import { _ } from "../../domain/languageSlice";
import Icn from '../../components/Icn';
import IconBtn from '../../components/IconBtn';
import DistributorAddEditEdgeDialog from '../../components/dialogs/DistributorAddEdgeDialog';
import { colors } from '../../maps/colors';
import DistributorAddEdgeToInstallerDialog from "../../components/dialogs/DistributorAddEdgeToInstallerDialog";

export default function EdgesPage(props) {

    const { distributorShowInstallerEdges, label } = props;

    const [edges, s_edges] = useState([]);
    const [open_add_dialog, s_open_add_dialog] = useState(false);
    const [open_distributor_add_edge_to_installer_dialog, s_open_distributor_add_edge_to_installer_dialog] = useState(false);

    const userRole = zibi.user.role[0];

    const getEdges = async () => {
        let cfg = { type: 'getEdges', data: {} };

        switch (userRole) {
            case 'DISTRIBUTOR_ADMIN':
                if (distributorShowInstallerEdges) {
                    const installer = props.installer;
                    cfg.data.installerId = installer._id;
                    cfg.data.distributorShowInstallerEdges = true;
                }
                break;
        }

        const edges_res = await api(cfg);
        s_edges(edges_res.map(edge => ({ ...edge, deviceTypeLabel: _(`device.${edge.deviceType.replace(/_/g, '').toLowerCase()}`) })));
    }

    useEffect(() => {
        getEdges();
    }, []);

    let headers = [
        { label: <Tx>edge.id</Tx>, field: '_id' },
        { label: <Tx>edge.number</Tx>, field: 'number' },
        { label: <Tx>edge.deviceType</Tx>, field: 'deviceTypeLabel' },
    ]

    let add_btn_fnc = s_open_add_dialog;
    let enableAdd = false;

    switch (userRole) {
        case 'SUPER_ADMIN':
            headers.push({ label: <Tx>sensor.table.distributorName</Tx>, field: 'distributorName' })
            headers.push({ label: <Tx>sensor.table.installerName</Tx>, field: 'installerName' })
            break;
        case 'DISTRIBUTOR_ADMIN':
            enableAdd = true;
            if (distributorShowInstallerEdges) {
                add_btn_fnc = s_open_distributor_add_edge_to_installer_dialog;
            } else {
                headers.push({ label: <Tx>sensor.table.installerName</Tx>, field: 'installerName' })
            }
            break;
    }

    return (
        <div style={{ height:'100%', overflowY:'scroll', padding: 20 }}>
            <PageTitle>
                <div style={{ position: 'relative' }}>

                    <Icn>edge</Icn> <Tx>page.edges.title</Tx>
                    {
                        label && <div style={{ color: colors.GRAY1, fontSize: 14 }}>[{label}]</div>
                    }
                    {
                        enableAdd && <IconBtn
                            style={{ position: 'absolute', right: 20 }}
                            onClick={() => add_btn_fnc(true)}>
                            add
                        </IconBtn>
                    }
                </div>
            </PageTitle>

            <Table data={edges} headers={headers} />

            {
                open_add_dialog && <DistributorAddEditEdgeDialog open={open_add_dialog} onClose={() => {
                    s_open_add_dialog(false);
                    getEdges();
                }} />
            }

            {
                open_distributor_add_edge_to_installer_dialog && <DistributorAddEdgeToInstallerDialog open={open_distributor_add_edge_to_installer_dialog} installer={props.installer} onClose={() => {
                    s_open_distributor_add_edge_to_installer_dialog(false);
                    getEdges();
                }} />
            }
        </div>
    )
}